export default "__VITE_ASSET__CIspRhPs__"